import {WidgetTreatmentDataInterestedV0Response} from './models/widget-treatment-data-interested-v0-response';
import {WidgetTreatmentDataInterestedV0CellValue} from './models/widget-treatment-data-interested-v0-cell-value';
import {WidgetTreatmentDataInterestedV0Value} from './models/widget-treatment-data-interested-v0-value';

export class WidgetTreatmentDataInterestedV0Utils {
  static queryResponseToCheckBoxResponse(queryResponse: unknown[], fields: {}, value: string[]): WidgetTreatmentDataInterestedV0Response[] {
    const keys = Object.keys(fields);
    const response: WidgetTreatmentDataInterestedV0Response[] = [];
    queryResponse.forEach((q: unknown) => {
      const obj = {};
      keys.forEach((outputKey: string) => {
        obj[outputKey] = q[fields[outputKey]];
      });
      response.push(obj as WidgetTreatmentDataInterestedV0Response);
    });

    return this.checkBoxSelectValue(response, value);
  }

  static createValue(widgetValue: WidgetTreatmentDataInterestedV0Value,
                     row: WidgetTreatmentDataInterestedV0Response[],
                     col: WidgetTreatmentDataInterestedV0Response[],
                     cells: WidgetTreatmentDataInterestedV0CellValue[]):
    WidgetTreatmentDataInterestedV0Value {
    const validColId = col?.map(i => i.uuid);
    const validRowId = row?.map(i => i.uuid);
    return {
      row: row?.map(r => r.uuid),
      col: col?.map(r => r.uuid),
      cell: cells && validColId?.length > 0 ? cells.filter((c) => {
        return validColId.includes(c?.col) && validRowId.includes(c?.row);
      }) : []
    } as WidgetTreatmentDataInterestedV0Value;
  }

  static getValidValue(value: WidgetTreatmentDataInterestedV0Value,
                       validRow: string[],
                       validCol: string[]): WidgetTreatmentDataInterestedV0Value {
    let col = [];
    let row = [];
    let cell = [];

    if (value) {
      if (value?.col?.length > 0) {
        col = value?.col.filter(c => validCol.includes(c));
      }

      if (value?.row?.length > 0) {
        row = value?.row.filter(c => validRow.includes(c));
      }

      if (value?.cell?.length > 0) {
        cell = value?.cell.filter(c => validRow.includes(c.row) && validCol.includes(c.col));
      }
    }
    return {col, row, cell} as WidgetTreatmentDataInterestedV0Value;
  }

  private static checkBoxSelectValue(checkBox: WidgetTreatmentDataInterestedV0Response[], value: string[]): WidgetTreatmentDataInterestedV0Response[] {
    if (value) {
      checkBox.forEach((c: WidgetTreatmentDataInterestedV0Response) => {
        c.checked = value?.includes(c.uuid);
      });
    }
    return checkBox;
  }
}
